import { render, staticRenderFns } from "./MovimientoShowData.vue?vue&type=template&id=2b9be510&scoped=true&"
import script from "./MovimientoShowData.vue?vue&type=script&lang=js&"
export * from "./MovimientoShowData.vue?vue&type=script&lang=js&"
import style0 from "./MovimientoShowData.vue?vue&type=style&index=0&id=2b9be510&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9be510",
  null
  
)

export default component.exports